import { render, staticRenderFns } from "./notifications-bar.vue?vue&type=template&id=7a360e1a&scoped=true"
import script from "./notifications-bar.vue?vue&type=script&lang=js"
export * from "./notifications-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a360e1a",
  null
  
)

export default component.exports